import {
  IRemitAccuracyFilters,
  IRemitAccuracyRow,
  IRemitAccuracyRowsRequest,
  IRemitAccuracySummary,
  IRemitCluster,
  IRemitClusterRequest,
  IRemitExcludedRow,
  IRemitPage,
} from "types/RemitAccuracy/RemitAccuracy";

import { api } from ".";

/** Drops empty filters so the query string carries only what was chosen. */
const toParams = (filter: object) =>
  Object.fromEntries(
    Object.entries(filter).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

/**
 * CLE-2818 — the Remit accuracy tab. Read-only, SuperAdmin on the API. Everything here is rebuilt by
 * the nightly job, so nothing on the tab invalidates it.
 */
const remitAccuracyQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getRemitAccuracySummary: builder.query<
      { data: IRemitAccuracySummary; message: string },
      /** `includeAi` is sent only when true: unchecked, the request is exactly what it was before. */
      IRemitAccuracyFilters & { includeAi?: boolean }
    >({
      query: (filters) => ({
        url: "remitAccuracy/summary",
        params: toParams(filters),
      }),
      providesTags: [{ type: "RemitAccuracy" as const, id: "SUMMARY" }],
    }),
    getRemitAccuracyCluster: builder.query<
      { data: IRemitCluster; message: string },
      IRemitClusterRequest
    >({
      query: (request) => ({
        url: "remitAccuracy/cluster",
        params: toParams(request),
      }),
    }),
    getRemitAccuracyRows: builder.query<
      { data: IRemitPage<IRemitAccuracyRow>; message: string },
      IRemitAccuracyRowsRequest
    >({
      query: (request) => ({
        url: "remitAccuracy/rows",
        params: toParams(request),
      }),
    }),
    getRemitAccuracyExcluded: builder.query<
      { data: IRemitPage<IRemitExcludedRow>; message: string },
      { reason?: string; accountId?: string; limit?: number; offset?: number }
    >({
      query: (filter) => ({
        url: "remitAccuracy/excluded",
        params: toParams(filter),
      }),
    }),
  }),
});

export const {
  useGetRemitAccuracySummaryQuery,
  useGetRemitAccuracyClusterQuery,
  useGetRemitAccuracyRowsQuery,
  useGetRemitAccuracyExcludedQuery,
} = remitAccuracyQueries;
